module.exports = __webpack_public_path__ + "img/utei.7119bb41.jpg";